export default "__VITE_ASSET__ZDrYoRQc__"